<section
  class="bv-vault-item-notes tw-mb-0"
  [ngClass]="{ 'tw-mb-0': disableSectionMargin && !hasCustomFields }"
  [formGroup]="additionalOptionsForm"
>
  <bit-form-field disableMargin>
    <bit-label>{{ "notes" | i18n }}</bit-label>
    <textarea bitInput rows="5" formControlName="notes"></textarea>
  </bit-form-field>
</section>

<vault-custom-fields
  (numberOfFieldsChange)="handleCustomFieldChange($event)"
  [disableSectionMargin]="disableSectionMargin"
></vault-custom-fields>

<section
  class="bv-vault-item-options tw-mb-0"
  [ngClass]="{ 'tw-mb-0': disableSectionMargin && !hasCustomFields }"
  [formGroup]="additionalOptionsForm"
>
  @if (passwordRepromptEnabled$ | async) {
    <div class="bv-vault-item-section">
      <h3 class="bv-vault-item-section__title">{{ "options" | i18n }}</h3>
      <bit-form-control disableMargin>
        <input type="checkbox" bitCheckbox formControlName="reprompt" />
        <bit-label>{{ "passwordPrompt" | i18n }}</bit-label>
      </bit-form-control>
    </div>
  }
</section>
